import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm3.606-11.05l-3.95 3.95-2.449-2.45-1.414 1.415 3.863 3.863 5.364-5.364-1.414-1.414z" }));
export default createSvgIcon(iconPath, "Approved");
//# sourceMappingURL=StatusApprovedIcon.js.map